var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding-top":"100px"}},[_c('img',{staticClass:"pic-404__parent",attrs:{"src":require("@/assets/404.png"),"alt":"404"}})])
}]

export { render, staticRenderFns }